export class PushCartRecommendations extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    window.setTimeout(() => this.render(), 500)
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    this.expanded = false
  }

  render () {
    fetch(this.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div')
        html.innerHTML = text

        const recommendations = html.querySelector('push-cart-recommendations')
        const hasItems =
          recommendations && recommendations.innerHTML.trim().length

        if (hasItems) {
          document
            .querySelectorAll('.psh-Recommendations')
            .forEach((container) => {
              container.innerHTML = recommendations.innerHTML
            })
        }

        this.expanded = !!hasItems
      })
      .catch((e) => {
        console.error(e)
      })
  }

  get expanded () {
    return this._expanded
  }

  set expanded (expanded) {
    this._expanded = expanded

    document
      .querySelector('.drw-Drawer[data-module-drawers-drawer="cart"] .drw-Drawer_Aside')
      ?.setAttribute('aria-expanded', expanded)

    document
      .querySelector('.psh-Cart_Recommendations')
      ?.setAttribute('loaded', expanded)
  }

  get url () {
    return this.dataset.url
  }
}

if (!customElements.get('push-cart-recommendations')) {
  customElements.define('push-cart-recommendations', PushCartRecommendations)
}

const { debounce } = window.BAO.Utils

class PushCartRecommendationsCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    // Start hidden until carousel is initialized
    if (this.els?.slides?.element) {
      this.els.slides.element.setAttribute('data-initialised', 'false')
    }

    this.handleResize = this.handleResize.bind(this)
    this.debouncedHandleResize = debounce(this.handleResize, 50)

    window.addEventListener('resize', this.debouncedHandleResize)

    window.setTimeout(() => this.render(), 500)
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    window.removeEventListener('resize', this.debouncedHandleResize)
    this.destroyCarousel()
  }

  handleResize () {
    if (!this.els?.slide?.exists) return

    const shouldHaveCarousel = !window.BAO.MediaBreakpoints.isMd

    if (shouldHaveCarousel && !this.carousel) {
      this.carousel = this.setupCarousel()
    } else if (!shouldHaveCarousel && this.carousel) {
      this.destroyCarousel()
    }
  }

  render () {
    if (!this.els?.slide?.exists) return

    if (window.BAO.MediaBreakpoints.isMd) return

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    const carousel = new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        slides: {
          perView: 2.5,
          spacing: 15,
        },
        created: (slider) => {
          slider.container.setAttribute('data-initialised', 'true')
          document.querySelector('.psh-Cart_Recommendations')?.setAttribute('data-loaded', 'true')
        },
      },
    )

    return carousel
  }

  destroyCarousel () {
    if (!this.carousel) return

    this.carousel.destroy(true)
    this.carousel = null

    // Reset attributes when carousel is destroyed
    if (this.els?.slides?.element) {
      this.els.slides.element.setAttribute('data-initialised', 'false')
    }
    document.querySelector('.psh-Cart_Recommendations')?.setAttribute('data-loaded', 'false')
  }
}

if (!customElements.get('push-cart-recommendations-carousel')) {
  customElements.define(
    'push-cart-recommendations-carousel',
    PushCartRecommendationsCarousel,
  )
}
